import { gql } from '@apollo/client';

export default gql`
  mutation approveDocument(
    $documentId: String!
    $documentType: String!
    $action: String!
    $note: String
    $signature: String
  ) {
    approveDocument(
      documentId: $documentId
      documentType: $documentType
      action: $action
      note: $note
      signature: $signature
    ) {
      ok
      message
      error
    }
  }
`;
